import { api, unwrap } from '@/shared/lib/api';
import type { AuthUser } from '@/stores/auth.store';

export interface TelegramLoginResponse {
  accessToken: string;
  user: AuthUser;
}

export const authService = {
  async loginWithTelegram(initData: string): Promise<TelegramLoginResponse> {
    const res = await api.post('/auth/telegram', { initData });
    return unwrap<TelegramLoginResponse>(res.data);
  },
  async me(): Promise<AuthUser> {
    const res = await api.get('/auth/me');
    return unwrap<AuthUser>(res.data);
  },
};
